import React from 'react';
import { PriceDisplay } from '../ui/PriceDisplay';
import { ProgressBar } from '../ui/ProgressBar';
export function BonusSection() {
  const bonuses = [{
    num: '01',
    title: 'Checklist de Seguridad Cosmética',
    desc: 'Una lista de verificación paso a paso para revisar cualquier fórmula antes de aplicarla. Confirma higiene, conservación, pH y estabilidad. Transforma el miedo técnico en una rutina de control que podés repetir siempre.',
    value: 17,
    accumulated: 144
  }, {
    num: '02',
    title: 'Guía de Conservantes Naturales',
    desc: 'El punto de dolor más repetido en todos los foros. Esta guía explica qué conservante usar, en qué porcentaje exacto, para qué tipo de fórmula y cómo verificar que funciona. Elimina la mayor fuente de miedo técnico de una vez.',
    value: 17,
    accumulated: 181
  }, {
    num: '03',
    title: 'Guía de Inicio para Emprendedoras',
    desc: 'Para las que quieren convertir lo que aprenden en un pequeño ingreso. Cómo presentar y vender productos artesanales por Instagram o en ferias locales. No necesitás ser experta para empezar — necesitás saber cómo mostrarlo.',
    value: 27,
    accumulated: 208
  }];
  return <section className="py-10 md:py-16 px-4 bg-white border-y border-divider" data-id="element-1">
      <div className="max-w-[800px] mx-auto" data-id="element-2">
        <div className="text-center mb-10" data-id="element-3">
          <h2 className="text-[26px] md:text-[32px] text-primary-dark mb-2" data-id="element-4">
            Si comprás hoy, también recibís
          </h2>
          <p className="text-[18px] italic text-primary" data-id="element-5">
            3 bonos que hacen que formular bien sea todavía más fácil.
          </p>
        </div>

        <div className="space-y-3" data-id="element-6">
          {bonuses.map((bonus, index) => <div key={index} className="bg-cream border-l-[3px] border-accent p-5 shadow-sm relative overflow-hidden" data-id="element-7">
              <div className="flex items-center gap-2 mb-2" data-id="element-8">
                <span className="text-[10px] uppercase font-bold text-accent tracking-[0.2em]" data-id="element-9">
                  BONO {bonus.num}
                </span>
                <h3 className="text-[18px] font-bold text-ink" data-id="element-10">
                  {bonus.title}
                </h3>
              </div>

              <p className="text-[15px] italic text-muted leading-[1.5] mb-3" data-id="element-11">
                {bonus.desc}
              </p>

              <div className="flex flex-col md:flex-row md:items-center justify-between border-t border-divider pt-3 mt-3" data-id="element-12">
                <p className="text-[12px]" data-id="element-13">
                  Valor:{' '}
                  <span className="line-through text-muted" data-id="element-14">
                    <PriceDisplay price={bonus.value} data-id="element-15" />
                  </span>{' '}
                  — <strong className="text-accent" data-id="element-16">INCLUIDO GRATIS</strong>
                </p>
                <p className="text-[11px] italic text-pain mt-1 md:mt-0 text-right font-bold" data-id="element-17">
                  Valor acumulado hasta aquí:{' '}
                  <PriceDisplay price={bonus.accumulated} data-id="element-18" /> USD
                </p>
              </div>
            </div>)}
        </div>

        {/* Progress Bar under bonuses */}
        <div className="mt-10" data-id="element-19">
          <ProgressBar data-id="element-20" />
        </div>
      </div>
    </section>;
}